import NewContactsIcon from './NewContactsIcon';

export default NewContactsIcon;


// WEBPACK FOOTER //
// ./src/components/NewContactsIcon/index.js